import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AiRecommendationSchema = withDefaults({
  type: 'ai-recommendation',
  objectExtensions: ['ai-recommendation'],
  fields: [
    {
      kind: 'attribute',
      name: 'action',
    },
    {
      kind: 'attribute',
      name: 'actionable',
    },
    {
      kind: 'attribute',
      name: 'breakdownOfPayment',
    },
    {
      kind: 'attribute',
      name: 'contextForRecommendation',
    },
    {
      kind: 'attribute',
      name: 'contextHexdigest',
    },
    {
      kind: 'attribute',
      name: 'recommendableType',
    },
    {
      kind: 'attribute',
      name: 'recommendableId',
    },
    {
      kind: 'attribute',
      name: 'recommendedTo',
    },
    {
      kind: 'attribute',
      name: 'responseJson',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'recommendable',
      type: 'tas-application',
      options: {
        async: false,
        inverse: 'aiRecommendations',
        polymorphic: false,
      },
    },
  ],
});

export default AiRecommendationSchema;
